(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRowTypeAttributeDetailController', CustomRowTypeAttributeDetailController);

    CustomRowTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomRowTypeAttribute'];

    function CustomRowTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomRowTypeAttribute) {
        var vm = this;

        vm.customRowTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customRowTypeAttributeUpdate', function(event, result) {
            vm.customRowTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
